import {ListQuestion} from '../../shared/models/list-question';
import {QuestionSetType} from '../../shared/models/question-set-type';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssessmentService } from 'app/shared/services/assessment.service';
import { Assessment } from 'app/shared/models/assessment';
import { Question } from 'app/shared/models/question';
import { QuestionType } from 'app/shared/models/question-type';
import { QuestionSet } from 'app/shared/models/question-set';

@Component({
  selector: 'dac-question-set-list-view',
  templateUrl: './question-set-list-view.component.html'
})
export class QuestionSetListViewComponent implements OnInit, OnChanges {
  @Input() assessment:Assessment;
  public selected:QuestionSet;
  
  constructor(
  ) { 
    }

  ngOnInit() {
    this.populateQuestionSetFromAssessment(this.assessment);
  }

  ngOnChanges() {
    this.populateQuestionSetFromAssessment(this.assessment);
  }

  getLabelsForSelected(questionSet:QuestionSet, question:Question) {
    if (questionSet.display_type == QuestionSetType.QUESTION_LIST) {
      let listQuestion = question as ListQuestion;
      return listQuestion.CustomLabels;
    }
    return questionSet.labels;
  }

  public isTextItem(item:Question) {
    return item.type == QuestionType.Textbox;
  }

  getClassesForItem(item:QuestionSet) {
    let isSelected = item == this.selected;
    let classes = {
      'primary-color': isSelected
      ,'white-text': isSelected
    };
    return classes;
  }

  private populateQuestionSetFromAssessment(assessment:Assessment) {
    if (!assessment) {
      return;
    }
    if (assessment.question_sets && assessment.question_sets.length) {
      this.selected = this.assessment.question_sets[0];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/question-set-list-view/question-set-list-view.component.ts